var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconAi = function SvgIconAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.09 6.059h4.236v20.724H22.09V6.06ZM13.853 5A6.36 6.36 0 0 0 7.5 11.353v15.43h4.236v-6.505h4.235v6.505h4.236v-15.43A6.36 6.36 0 0 0 13.853 5Zm2.118 11.043h-4.235v-4.69a2.12 2.12 0 0 1 2.117-2.117 2.12 2.12 0 0 1 2.118 2.117v4.69Z",
    fill: "#C1CED9"
  })));
};

export default SvgIconAi;